import React from 'react';
import { RecipientsPicker } from '../../../../shares/prefabs/RecipientsPicker';

export const ContractRecipientsPicker = (props) => {
  const { value, onChange, locked, ...restProps } = props;

  return (
    <RecipientsPicker
      value={value}
      onChange={onChange}
      locked={locked}
      {...restProps}
    />
  );
};
